export const not = <Inputs extends any[]>(
  wrappedFunction: (...inputs: Inputs) => boolean | undefined | null
) => {
  return (...inputs: Inputs) => !wrappedFunction(...inputs)
}
